export default function PrintFunction(printElement) {
  if (!printElement) {
    console.error("Print element is null or undefined");
    alert("Nothing to print. Please try again.");
    return;
  }

  const elementHTML = printElement.outerHTML;
  const iframe = document.createElement("iframe");
  iframe.style.position = "absolute";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "none";

  document.body.appendChild(iframe);

  const iframeDoc = iframe.contentWindow.document;
  const printContentHTML = elementHTML;

  iframeDoc.open();
  iframeDoc.write(
    `<html>
      <head>
        <title>Print Report</title>
        <!-- Bootstrap Icons -->
        <link href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.3/font/bootstrap-icons.css" rel="stylesheet">
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.0-beta3/dist/css/bootstrap.min.css" rel="stylesheet">
        
        <style>
          /* Complete reset - remove all margins and padding */
          * {
            box-sizing: border-box !important;
          }
          
          html, body {
            width: 100% !important;
            height: 100% !important;
            font-family: Arial, sans-serif;
            background: white;
          }
          
          @page {
            margin: 0 !important;
            padding: 0 !important;
          }
          
          @media print {
            html, body {
              margin: 0 !important;
              padding: 0 !important;
              width: 100% !important;
              height: 100% !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
            
            .no-print {
              display: none !important;
            }
            
            table {
              page-break-inside: avoid;
            }
            
            tr {
              page-break-inside: avoid;
            }
          }
          
          /* Remove Bootstrap default margins/padding */
          .container,
          .container-fluid,
          .row,
          /* Remove any default spacing from common elements */
        </style>
      </head>
      <body>`
  );

  iframeDoc.write(printContentHTML);

  // Adding the script for the onload callback function
  iframeDoc.write(`
    <!-- Bootstrap JS (optional, for any interactive elements) -->
    <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.0-beta3/dist/js/bootstrap.bundle.min.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/dompurify/2.3.3/purify.min.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js"></script>
    
    <script>
      window.onload = function() {
        // Small delay to ensure styles are loaded
        setTimeout(function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          }
        }, 100);
      };
    </script>
  `);

  iframeDoc.write("</body></html>");
  iframeDoc.close();
}
